import Util from '../../../forecast-app/shared/util/util';
import {STRING_COMPARE} from '../../../constants';

export const filterArray = (array, text) => {
	var filteredArray = null;
	filteredArray = array.filter(object => {
		return Util.normalizedIncludes(object.name, text, STRING_COMPARE.STARTS_WITH);
	});
	return filteredArray.slice(0, 5);
};

export const normalizeIndex = (selectedIndex, max) => {
	let index = selectedIndex % max;
	if (index < 0) {
		index += max;
	}
	return index;
};
